import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { OperatorContext, useOperators } from "@/components/mobile/operators";
import { OperatorPicker } from "@/components/mobile/OperatorLogo";

const StockBadge = ({ c, testid }) => (
  <span className={`text-xs font-medium ${c && c.low ? "text-amber-600" : "text-slate-600"}`} data-testid={testid}>{c ? `${c.stock} in giacenza` : "…"}</span>
);

export const LAST_OP = "markoo:lastOperator";
export const rememberOp = (k) => { try { localStorage.setItem(LAST_OP, k); } catch { /* storage non disponibile */ } };
export const lastOp = () => { try { return localStorage.getItem(LAST_OP) || ""; } catch { return ""; } };

export const WithOperator = ({ title, description, testid, only, stock = false, note, choose = false, children }) => {
  const all = useOperators();
  const [params, setParams] = useSearchParams();
  const [counts, setCounts] = useState(null);
  useEffect(() => {
    if (!stock) return undefined;
    const load = () => api.get("/sim-stock/counts").then((r) => setCounts(Object.fromEntries((r.data.items || []).map((i) => [i.key, i])))).catch(() => {});
    load();
    window.addEventListener("sim-changed", load);
    return () => { window.removeEventListener("sim-changed", load); };
  }, [stock]);
  if (!all) return <p className="text-sm text-muted-foreground">Caricamento…</p>;
  const ops = all.filter((o) => o.kind === "sim" && o.active && (!only || only(o)));
  const op = ops.find((o) => o.key === params.get("operatore")) || ops.find((o) => o.key === lastOp()) || (choose && ops.length > 1 ? null : ops[0]);
  const choosing = !op && ops.length > 0;
  const pick = (k) => { rememberOp(k); setParams((p) => { const n = new URLSearchParams(p); n.set("operatore", k); return n; }, { replace: true }); };
  const size = choosing ? "lg" : choose ? "sm" : "md";
  const compact = choose && !!op;
  return (
    <div className={compact ? "space-y-4" : "space-y-6"} data-testid={testid}>
      {compact ? <div className="flex flex-wrap items-center gap-x-4 gap-y-2" data-testid="operator-switch">
        <h1 className="font-head text-xl font-bold tracking-tight" data-testid={`${testid}-title`}>{title}</h1>
        <OperatorPicker ops={ops} value={op.key} onChange={pick} compact />
        <span className="sr-only" data-testid="operator-current">Stai lavorando su {op.name}</span>
      </div> : <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Mobile</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-2" data-testid={`${testid}-title`}>{title}</h1>
        <p className="text-sm text-muted-foreground mt-1">{description}</p>
      </div>}
      {!ops.length ? <><p className="text-sm text-muted-foreground" data-testid="no-sim-operators">Nessun operatore SIM attivo al momento.</p>{note && note(all)}</> : <>
        {!compact && (ops.length > 1 || stock) && <div className="space-y-2" data-testid="operator-switch">
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{choosing && !stock ? "Su quale operatore vuoi lavorare?" : stock ? "Per quale operatore ordini le SIM?" : "Operatore"}</p>
          <OperatorPicker ops={ops} value={op?.key} onChange={pick} size={size} dimOthers={choose && !!op} extra={stock ? (o) => <StockBadge c={counts?.[o.key]} testid={`operator-picker-${o.key}-stock`} /> : undefined} />
          {choosing && <p className="text-sm text-muted-foreground" data-testid="operator-choose-hint">{stock ? "Tocca il logo dell'operatore: poi vedi la giacenza, ordini le SIM e controlli i movimenti." : "Tocca il logo dell'operatore: poi trovi attivazione, ricarica, info SIM e cambio promo."}</p>}
          {choose && op && <p className="text-sm" data-testid="operator-current">Stai lavorando su <strong>{op.name}</strong> · tocca un altro logo per cambiare.</p>}
        </div>}
        {note && note(all)}
        {op && <OperatorContext.Provider value={op}><div key={op.key} className="space-y-5">{children}</div></OperatorContext.Provider>}
      </>}
    </div>
  );
};
